import React from "react";

const Supercharts = () => {
  return <div>Supercharts</div>;
};

export default Supercharts;
